// @flow
import React from 'react';

import AccountExistsIllustration from '../../../../components/Icons/SelfEnrollment/AccountExists';
import PageHeader from '../../PageHeader';
import PageButtons from '../../PageButtons';
import useContactNumber from '../../useContactNumber';
import { SCENARIOS } from '../../constants';

import styles from './styles.module.scss';

const AccountExists = () => {
  const phoneNumber = useContactNumber();

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <AccountExistsIllustration />
      </div>
      <PageHeader
        headerId="app.self-enroll.found.account-exists.header"
        subHeaderId="app.self-enroll.found.account-exists.sub-header"
        alignCenter
      />
      <PageButtons scenario={SCENARIOS.ACCOUNT_EXISTS} phoneNumber={phoneNumber} />
    </div>
  );
};

export default AccountExists;
